const imageAsset = {};

imageAsset['expedia_en'] = 'https://a.travel-assets.com/egds/marks/onekey__expedia.svg'; //expediaLogo;
imageAsset['hotels_en'] = 'https://a.travel-assets.com/egds/marks/onekey__hotels__english.svg'; //hotelsENLogo;
imageAsset['hotels_es'] = 'https://a.travel-assets.com/egds/marks/onekey__hotels__spanish.svg'; //hotelsESLogo;
imageAsset['hotels_pt'] = 'https://a.travel-assets.com/egds/marks/onekey__hotels__portuguese.svg'; //hotelsPTLogo;
imageAsset['hotels_zh'] = 'https://a.travel-assets.com/egds/marks/onekey__hotels__english.svg';

export default imageAsset;
export { FooterLogoAssets, VrboHeritageBrandEapIds } from './footer-logo.assets';
export { SocialLoginAssets } from './social-login.assets';
